<template>
    <div class="travel hml_whplt">
        <swiperList :swiperStyle="{padding: '1.28rem 0 .5rem'}">
            <div class="tripRoute">
                <img src="@/assets/img/secondLevelPage/tripBg.png">
                <div class="tripRouteContent">
                    <div class="map">
                        <img :src="this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[0].thumb">
                    </div>
                    <div class="textContent">
                        <h2 class="title" v-html="list1.title"></h2>
                        <ul class="list">
                            <li
                            v-for="(item,index) in list1.list"
                            :key="index"
                            >
                                <h3>{{ item.title }}<span>{{ item.time }}</span></h3>
                                <p>{{ item.text }}</p>
                            </li>
                        </ul>
                    </div>
                    <div class="textContent textContent1">
                        <h2 class="title" v-html="list2.title"></h2>
                        <ul class="list">
                            <li
                            v-for="(item,index) in list2.list"
                            :key="index"
                            >
                                <h3>{{ item.title }}<span v-if="item.time">{{ item.time }}</span></h3>
                                <p>{{ item.text }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="swiper-container travelSwiper">
                <ul class="swiper-wrapper">
                    <li class="swiper-slide" v-for="(item,index) in list3" :key="index">
                        <div class="img">
                            <img :src="item.img">
                        </div>
                        <h2 class="title">{{ item.title }}</h2>
                        <a class="pone" :href="'tel:'+item.phone">
                            <img src="@/assets/svg/secondLevelPage/phone.svg">
                            预约咨询
                        </a>
                    </li>
                </ul>
            </div>
        </swiperList>
    </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            list1: [],
            list2: [],
            list3: []
        }
    },
    created(){
        this.list1 = this.staticeData.text.trip.list1;
        this.list2 = this.staticeData.text.trip.list2;
        let content = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[0].content.replace(/\n/g,"");
        content.replace(/\n/g,"").split("<br />").forEach(item => {
            if(item.length > 10){
                let arr = item.split("|");
                let obj = {};
                obj.title = arr[0];
                obj.phone = arr[1];
                obj.img = this.getImgSrc(arr[2],[],false);
                this.list3.push(obj);
            }
        });
        console.log();
    },
    mounted(){
        let swiper1 = new Swiper('.travelSwiper',{
            slidesPerView: 'auto',
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
        });
    },
    computed: {
        ...publicData.mapState(["levelThreeIndex","secondLevelIndex","firstLevelIndex","allData","staticeData","staticeData"]),
    }
}
</script>

<style lang="scss" scoped>
.travel{
    .tripRoute{
        position: relative;
        >img{
            height: 12rem;
        }
        .tripRouteContent{
            width: 100%;
            height: auto;
            position: absolute;
            left: 0;
            top: 0;
            padding: .56rem .64rem 0;
            .map{
                width: 100%;
                height: 3.55rem;
                margin-bottom: .26rem;
                img{
                    height: 100%;
                }
            }
            .textContent{
                margin-top: .63rem;
                display: flex;
                h2{
                    font-size: .4rem;
                    // font-family: "zhanku";
                    margin-right: .24rem;
                }
                &.textContent1{
                    .list{
                        li{
                            h3{
                                display: flex;
                                flex-direction: column;
                                span{
                                    margin-top: .2rem;
                                }
                            }
                        }
                    }
                }
                .list{
                    border-left: .01rem solid #999;
                    padding-left: .3rem;
                    li{
                        font-size: .28rem;
                        color: #666;
                        margin-top: .36rem;
                        white-space: nowrap;
                        h3{
                            color: #333;
                            font-size: .3rem;
                            font-weight: bold;
                            span{
                                font-size: .24rem;
                            }
                        }
                        p{
                            width: 4.4rem;
                            height: auto;
                            color: #999;
                            font-size: .24rem;
                            margin-top: .16rem;
                            overflow: hidden;
                            white-space: pre-wrap;
                            line-height: .33rem;
                        }
                        &:first-of-type{
                            margin-top: 0;
                        }
                    }
                }
            }
        }
    }
    .travelSwiper{
        width: 100%;
        height: 3.8rem;
        padding-left: .3rem;
        .swiper-wrapper{
            display: flex;
            align-items: center;
        }
        li{
            width: 2.4rem;
            height: 3.2rem;
            box-shadow: 0 .05rem .13rem 0 rgba(64,64,64,.3);
            border-radius: .06rem;
            overflow: hidden;
            margin-right: .26rem;
            background: #fff;
            >.img{
                width: 100%;
                height: 1.58rem;
                overflow: hidden;
                img{
                    width: 100%!important;
                    height: 100%!important;
                }
            }
            .title{
                font-size: .28rem;
                color: #666;
                padding: 0 .14rem;
                margin-top: .25rem;
                line-height: .4rem;
            }
            .pone{
                display: block;
                width: 1.66rem;
                height: .54rem;
                border: .01rem solid #3289FF;
                margin: .2rem auto 0;
                border-radius: .1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    width: .25rem;
                    margin-right: .1rem;
                }
                color: #3289FF;
                font-size: .24rem;
            }
        }
    }
}
</style>